/*eslint-disable*/
import * as types from './mutation-types';
import $Cookies from 'js-cookie';
import $qs from 'qs';
import { common, commonApi } from '@/common/index';
import {  queryListBuried , updateBuried} from '@/common/api/bindAuthenticate.js'
import { inviteInfo } from '@/common/api/team.js'


export const Login = function ({commit, state}, UUID) {
  commit(types.LOGIN,UUID)
};

export const checkLogin = function ({commit, state}, uuids) {

  let url = window.location.href;
  let UUID = $qs.parse(url.split('?')[1]).UUID;

  if (UUID === undefined) {
    UUID = $Cookies.get('UUID') || uuids || window.localStorage.getItem('UUID')
  } else {
    $Cookies.set('UUID', UUID)
  }

  // let UUID = $Cookies.get('UUID');

  let obj = {};
  if(UUID) {
    obj['isLogin'] = true;
    obj['UUID'] = UUID;
    commit(types.CHECK_LOGIN, obj)
  }else {
    commit(types.LOGIN_OUT)
  }

};

export const check_isHorizontal = function({commit, state}) {
  let bool = false;
  if(window.orientation===180||window.orientation===0){
    bool = false;
  }
  if(window.orientation===90||window.orientation===-90){
    bool = true;
  }
  commit('set_isHorizontal',bool)
}

// 老虎机图片地址
export const setPicLink = function({commit},picLink) {
  commit(types.SET_SLOT_PICLINK,picLink)
}

// 奖池金额
export const addJackPotMoney = function ({commit}) {

  let num = Math.random()*15;
  let num2 = Math.random()*555
  let moneyNum = parseFloat(num.toFixed(2));
  let moneyNum2 = parseFloat(num2.toFixed(2));
  commit(types.ADD_SLOT_JACKPOT,moneyNum);
  commit(types.ADD_SLOT_JACKPOT3,moneyNum2);
}

/**
 * 多彩宝 */
export const getColorService = function ({commit}) {
  commonApi.HOMEBEFORE.service()
    .then(customerUrl => {
      customerUrl && commit(types.SET_COLOR_SERVICE,customerUrl)
    })
    .catch(err => {})
}
/**
 * 金沙
 * */
export const getJinService = function ({commit}) {
  commonApi.HOMEBEFORE.service()
    .then(initUrl => {
      initUrl && commit(types.SET_JIN_SERVICE,initUrl.customerUrl)
      initUrl && commit(types.INIT_LIST,initUrl)
      commit(types.GET_DOWNLOAD_URL,initUrl.appDownload)
      commit('setIsNameVerify', initUrl.isNameVerify === '1')
    })
    .catch(err => {})
}

/**
 * Build04
 * */

export const getFourService = function ({commit}) {
  commonApi.HOMEBEFORE.service()
    .then(customerUrl => {
      customerUrl && commit(types.SET_Four_SERVICE,customerUrl)
    })
    .catch(err => {})
}

/**
 * 下载链接
 * */
export const getDownloadUrl = function ({commit}) {
  commonApi.HOMEBEFORE.download()
    .then(customerUrl => {
      commit(types.GET_DOWNLOAD_URL,customerUrl.data.appDownload)
    })
    .catch(err => {})
}

// 用户连续签到天数

export const getcheckCount = function ({commit}) {
  commonApi.SIGN.getUserCheckInfo()
    .then(data => {
      commit('setcheckCount',data.data.data.checkCount)
    })
    .catch(err => {})
}

// build07  查看im和电竞牛是否维护

export const getEsportStatus = function({commit}){
  let params = {
    gameType: '3',
    pageNo: 1,
    pageSize: 30,
  };
  commonApi.HOMEBEFORE.gamePlatform(params)
    .then((data) => {
      // 获取平台
      let bool =  data.list.some((item)=>{
        return item.platformCode=='IM'
      })
      let bool2 = data.list.some((item)=>{
        return item.platformCode=='ESPORTS'
      })
      commit('setImSport',bool)
      commit('setEsport',bool2)
    })
}

export const getHasMessage = function( {commit} ){
  let UUID = $Cookies.get('UUID') || window.localStorage.getItem('UUID')
  let params = {
    UUID: UUID,
    pageNo: 1,
    pageSize: 100,
  };
  commonApi.VIP.getMsgSiteList(params)
  .then( data => {
    if(data.list){
      let bool =  data.list.some((item)=>{
        return item.isRead == false
      })
      commit('setHasMessage',bool)
    }else{
      commit('setHasMessage',false)
    }
  })

}

export const getFirstInfo = function({commit, state}){
  commonApi.USER.getUserInfo()
    .then((data)=>{
      commit(types.SET_USER_INFO,data)
    })
    .catch((err)=>{})
};

export const getInEmail = function({commit, state}){
  let params = {
    UUID:state.UUID,
    pageNo:1,
    pageSize:10,
    read: 0
  }
  commonApi.VIP.getMsgSiteList(params)
  .then(data=>{
    commit('setInEmailNum',data.total)
  })
  .catch(err=>{
    commit('setInEmailNum',0)
  })

}

//获取全游戏平台信息
export const getallgameInfo = function({commit}){
  commonApi.HOMEBEFORE.allGameInfo()
  .then(data =>{
    this.gamePlatformList = data;
    commit('setallgameInfo',data)
  })
}

// 获取优惠
export const getBonusInfo = function({commit,state}){
  commonApi.DISCOUNTS.queryBonusArticleTypeList()
  .then(data =>{

    commit('setGameTypes',data)

    let param = {
      typeId:state.gameTypes[0].articleId,
      platform:'app',
      pageNo: 1,
      pageSize: 200,
    }
    commonApi.DISCOUNTS.queryBonusArticleInfoList(param)
    .then(data =>{

      commit('setAllBonusArticle',data.list)

    })
  })
}

// 获取优惠(02B,03B)
export const getBonusInfo_ = function({commit,state}){
  commonApi.DISCOUNTS.queryBonusArticleTypeList()
  .then(data =>{

    commit('setGameTypes',data)

    // let param = {
    //   typeId:state.gameTypes[0].articleId,
    //   platform:'app',
    //   pageNo: 1,
    //   pageSize: 200,
    // }
    // commonApi.DISCOUNTS.queryBonusArticleInfoList(param)
    // .then(data =>{

    //   commit('setAllBonusArticle',data.list)

    // })
  })
}

// 获取新链接列表
export const newinitLinkList = function ({commit, state}) {
  commonApi.HOMEAFTER.getFrontConfigList()
    .then((data)=>{
      commit(types.FRONTCONFIG_LIST,data)
      // data.isNameVerify == '1'?commit('setIsNameVerify',true):commit('setIsNameVerify',false)
    })
    .catch((err)=>{
      Message.warning(err)
    })
};


// new 802及以后
import { refresh, initSystem, getFrontConfig, getUserInfo, logout } from '@/common/api/system.js'
import { getBrowserInfo } from '@/common/utils/common.js'
import { getCollectIds } from '@/common/api/game.js'
import { takebackAmount, refreshGameAccount } from '@/common/api/Amount.js'
function loadJsCode(code){
  let script = document.createElement('script');
  script.type = 'text/javascript';
  script.defer ='defer'
  //for Chrome Firefox Opera Safari
  script.appendChild(document.createTextNode(code));
  //for IE
  //script.text = code;
  document.head.appendChild(script);
}
function loadnoscript(iframeSrc){
  let noscript = document.createElement('noscript');
  let iframe  = document.createElement('iframe');
  iframe.src  = iframeSrc;
  iframe.height = 1;
  iframe.width = 1;
  iframe.style = 'display:none';
  noscript.appendChild(iframe)
  document.body.appendChild(noscript);
}
// 游客获取服务器信息
export const initSystemInfo = function({ commit, state }) {
  initSystem({}).then(([data, err, res]) => {
    if (!err){
      // console.log(data)
      if(!!data.googleType && !!data.googleId){
        if(data.googleType == 10){//gtag
          window.onload=function(){
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.src  = 'https://www.googletagmanager.com/gtag/js?id='+data.googleId;
            script.defer ='defer'
            // script.appendChild(document.createTextNode(code));
            document.head.appendChild(script);
          }
          loadJsCode(`window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
        
          gtag('config', '${data.googleId}');`);
        }else if(data.googleType == 20){//gtm
          window.onload=function(){
            loadnoscript('https://www.googletagmanager.com/ns.html?id='+data.googleId)
          }
          loadJsCode(`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${data.googleId}');`);
        }
      }
      if(!!data.pageBuryingId){
        window.onload=function(){
          loadnoscript('https://www.facebook.com/tr?id='+data.pageBuryingId+'&ev=PageView&noscript=1')
        }
        loadJsCode(`!function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${data.pageBuryingId}');
        fbq('track', 'PageView');`);
      }
      if(!!data.snapPixelId){
        loadJsCode(`(function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()
          {a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
          a.queue=[];var s='script';r=t.createElement(s);r.async=!0;
          r.src=n;var u=t.getElementsByTagName(s)[0];
          u.parentNode.insertBefore(r,u);})(window,document,
          'https://sc-static.net/scevent.min.js');
          
          snaptr('init', '${data.snapPixelId}', {
          'user_email': 'INSERT_USER_EMAIL'
          });
          
          snaptr('track', 'PAGE_VIEW');`);
      }
      commit(types.INIT_LIST, data)
    }
  })
}

// 代理联系方式
export const connactLists = function({ commit, state }) {
  getFrontConfig({}).then(([data, err, res]) => {
    if (!err) commit(types.FRONTCONFIG_LIST,data)
  })
}

// 刷新登录状态
var refreshTimer = null
export const refreshLogin = function({ commit, state }, param = {}) {
  const UUID = param.UUID || $Cookies.get('UUID') || window.localStorage.getItem('UUID')
  clearInterval(refreshTimer)
  if (!UUID) return
  refreshTimer = setInterval(() => {
    refresh({ UUID }).then(([data, err, res]) => {
      console.log('refreshLogin')
      if (err) { // 登录过期
        commit(types.LOGIN_OUT)
        $Cookies.remove('UUID')
        window.localStorage.removeItem('UUID');
        if (param.router) param.router.replace({ path: '/' })
        clearInterval(refreshTimer)
      }
    })
    if ((!$Cookies.get('UUID') && !window.localStorage.getItem('UUID')) && state.isLogin) {
      commit(types.LOGIN_OUT)
      if (param.router) param.router.replace({ path: '/' })
      clearInterval(refreshTimer)
    }
  }, 60 * 60 * 1000)
}

// 获取用户信息
export const refreshUserInfo = function({ commit, state }, type = 0) { // 0 刷新用户信息使用 1 登录使用
  const params = { domain: document.domain, ipInfo: '' }
  if ($Cookies.get('UUID') || window.localStorage.getItem('UUID')) {
    params.UUID = $Cookies.get('UUID') || window.localStorage.getItem('UUID')
    commit(types.LOGIN, params.UUID)
  } else {
    return
  }
  params.browser = getBrowserInfo()[0]//取到完整信息
  params.deviceId = $Cookies.get('deviceId')
  if(params.deviceId === undefined || params.deviceId===''){
    let timeStr = new Date().getTime().toString()
    let str = Math.random().toString().slice(-6)
    params.deviceId = timeStr + str
    $Cookies.set('deviceId', params.deviceId, { expires: 2000 })
  }
  getUserInfo(params, type).then(([data, err, res]) => {
    if(res.data.code == 998) commit('SET_FORCE_CHANGE_PASSWORD', true);
    if (!err) {
      if (state.refreshAccount) {
        let timer = setTimeout(() => {
          commit(types.SET_USER_INFO, data)
          commit('setRefreshAccount', false) // 重置刷新账户余额状态完成
          clearTimeout(timer)
        }, 1500)
      } else {
        commit(types.SET_USER_INFO, data)
      }

      // 首存查询
      queryListBuried({type:1, UUID: $Cookies.get('UUID') || window.localStorage.getItem('UUID') }).then(([data, err, res_]) => {
        if (!err) {
          let orderDetails = JSON.parse(data.list[0].orderDetails);
          // console.log(orderDetails)
          if(data.list[0].report === 0){ //首存未上报
            //上报首存
            actionLogEvent("af_firstrecharge", { af_revenue: orderDetails.orderAmount })  //新包
            if(state.linkList.pageBuryingId)  fbq('track', 'firstPurchase', {value: orderDetails.orderAmount, currency: 'INR'});  //有FBID下发 
            if(state.linkList.sharechatId)  scq('Purchase', 'pre_defined') 
            if(state.linkList.snapPixelId)  snaptr('track','PURCHASE')
            // 更改上报状态
            updateBuried({id:data.list[0].id, UUID: $Cookies.get('UUID') || window.localStorage.getItem('UUID') }).then(([data, err, res_]) => {
              if (!err) {
              }
            })
          }
        }
      })
      // 复存查询
      queryListBuried({type:2, UUID: $Cookies.get('UUID') || window.localStorage.getItem('UUID')}).then(([data_, err_, res_]) => {
        if (!err_) {
          let orderDetails = JSON.parse(data_.list[data_.list.length -1].orderDetails);
          if(data_.list[data_.list.length -1 ].report === 0){  //复存未上报
            actionLogEvent("af_recharge", { af_revenue: orderDetails.orderAmount })
            if(state.linkList.pageBuryingId)  fbq('track', 'Purchase', {value: orderDetails.orderAmount, currency: 'INR'});  //有FBID下发
            if(state.linkList.sharechatId)  scq('Purchase', 'pre_defined')
            if(state.linkList.snapPixelId)  snaptr('track','PURCHASE') 
            updateBuried({id:data_.list[data_.list.length -1].id, UUID: $Cookies.get('UUID') || window.localStorage.getItem('UUID')}).then(([data, err, res_]) => {
              if (!err) {
              }
            })
          }
        }
      })
      // 邀请优惠信息
      inviteInfo({UUID: $Cookies.get('UUID') || window.localStorage.getItem('UUID')}).then(([data, err]) => {
        if (!err) {
          const { buttonDisplay , buttonStatus , claimedBonus } = data
          commit('setInviteInfo', {claimedBonus,buttonStatus,buttonDisplay})
        }
      })
    }
  })
}

// 获取收藏列表id
export const getCollectIdsInfo = function({ commit, state }, uuid) {
  if (!$Cookies.get('UUID') && !window.localStorage.getItem('UUID')) return
  getCollectIds({ UUID: uuid || $Cookies.get('UUID') || window.localStorage.getItem('UUID')}).then(([data, err, res]) => {
    console.log(data)
    if (!err && data.length) commit('setGameCollect', data)
  })
}

// 刷新账户余额 type 1 = 刷新账户余额  2 = 取出全部的金额，用于提现等页面 isHand 标识是否手动
export const refreshAccount = function({ commit, state }, param = {}) {
  const { type, isHand, router } = Object.assign({}, { type: 1, isHand: true }, param)
  if (!$Cookies.get('UUID') && !window.localStorage.getItem('UUID')) {
    if (isHand) {
      if (!document.getElementById('popupLogin')) { // 判断是否为弹起的登录 页面登录
        if (router) router.push({ path: '/login' })
      } else { // 弹起登录
        commit('SET_LOGIN_SHOW')
      }
    }
    return
  }
  if (state.refreshAccount) return
  if (isHand) commit('setRefreshAccount', true) // 重置刷新账户余额状态进行
  let _ajax = null
  if (type === 1) _ajax = refreshGameAccount
  if (type === 2) _ajax = takebackAmount
  if (!_ajax) return
  _ajax({ UUID: $Cookies.get('UUID') || window.localStorage.getItem('UUID')}).then(([data, err, res]) => {
    if (!err) {
	  if (param.fn) param.fn()
      refreshUserInfo({ commit, state }, 0)
    } else {
      commit('setRefreshAccount', false)
    }
  })
}

// 退出登录
export const Logout = function({ commit, state }, uuid) {
  if (!$Cookies.get('UUID') && !window.localStorage.getItem('UUID')) return
  return new Promise((resolve, reject) => {
    logout({ UUID: uuid || $Cookies.get('UUID') || window.localStorage.getItem('UUID')}).then(([data, err, res]) => {
      console.log(res)
      console.log(err)
      if (!err) {
        commit('LOGIN_OUT')
        resolve(true)
      } else {
        reject(res.data.msg)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/common/store/actions.js